import ajaxLoader from "./ajax-loader";

const ELEMENT_SELECTOR = "[data-ajax-loader]";
const element = document.querySelector(ELEMENT_SELECTOR);

if (element) {
	ajaxLoader(element);
}



// WEBPACK FOOTER //
// ./project/client/src/core/components/ajax-loader/index.js